import React, { ReactNode, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import jwtAxios from '../jwt-auth';
import axios, { AxiosError } from 'axios';

type Props = {
  children: ReactNode;
};
function RQProvider({ children }: Props) {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retryOnMount: true,
          refetchOnReconnect: false,
          staleTime: 1000 * 60,
          retry: false,
          queryFn: async ({ queryKey }) => {
            const [url, params] = queryKey;
            try {
              const result = await jwtAxios.get(url, { params });

              const { data, headers } = result;

              if (headers && headers['x-total-count']) {
                return {
                  data,
                  totalCount: parseInt(headers['x-total-count'], 10),
                };
              }
              return data;
            } catch (error: any) {
              if (axios.isAxiosError(error)) {
                throw error; // AxiosError 객체를 그대로 던짐 (useQuery에서 타입 확인하여 사용할 것)
              } else {
                throw new Error('An unexpected error occurred'); // 그외 오류
              }
            }
          },
        },
      },
    }),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default RQProvider;
